import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var WatchList =
/*#__PURE__*/
function (_BaseData) {
  _inherits(WatchList, _BaseData);

  function WatchList() {
    _classCallCheck(this, WatchList);

    return _possibleConstructorReturn(this, _getPrototypeOf(WatchList).call(this, "WatchList"));
  }

  _createClass(WatchList, [{
    key: "Get",
    value: function () {
      var _Get = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(id) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetWatchListViewModel/").concat(id)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function Get(_x) {
        return _Get.apply(this, arguments);
      }

      return Get;
    }()
  }, {
    key: "CreateNewModel",
    value: function () {
      var _CreateNewModel = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(propertyId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/CreateNewModel/").concat(propertyId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function CreateNewModel(_x2) {
        return _CreateNewModel.apply(this, arguments);
      }

      return CreateNewModel;
    }()
  }, {
    key: "GetWatchlistHistory",
    value: function () {
      var _GetWatchlistHistory = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(propertyId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/".concat(this._controller, "/GetWatchlistHistory/").concat(propertyId)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function GetWatchlistHistory(_x3) {
        return _GetWatchlistHistory.apply(this, arguments);
      }

      return GetWatchlistHistory;
    }()
  }, {
    key: "GetTypes",
    value: function () {
      var _GetTypes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("/api/".concat(this._controller, "/GetTypes")));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function GetTypes() {
        return _GetTypes.apply(this, arguments);
      }

      return GetTypes;
    }()
  }, {
    key: "GetProgramTypes",
    value: function () {
      var _GetProgramTypes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("/api/".concat(this._controller, "/GetProgramTypes")));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function GetProgramTypes() {
        return _GetProgramTypes.apply(this, arguments);
      }

      return GetProgramTypes;
    }()
  }, {
    key: "GetResponsibilityTypes",
    value: function () {
      var _GetResponsibilityTypes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios.get("/api/".concat(this._controller, "/GetResponsibilityTypes")));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function GetResponsibilityTypes() {
        return _GetResponsibilityTypes.apply(this, arguments);
      }

      return GetResponsibilityTypes;
    }()
  }, {
    key: "GetWeaknessTypes",
    value: function () {
      var _GetWeaknessTypes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios.get("/api/".concat(this._controller, "/GetWeaknessTypes")));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function GetWeaknessTypes() {
        return _GetWeaknessTypes.apply(this, arguments);
      }

      return GetWeaknessTypes;
    }()
  }, {
    key: "GetWatchListList",
    value: function () {
      var _GetWatchListList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(year, month, watchlistTypeId) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", axios.get("/api/".concat(this._controller, "/GetWatchListList"), {
                  params: {
                    year: year,
                    month: month,
                    watchlistTypeId: watchlistTypeId
                  }
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function GetWatchListList(_x4, _x5, _x6) {
        return _GetWatchListList.apply(this, arguments);
      }

      return GetWatchListList;
    }()
  }, {
    key: "GetWatchListReport",
    value: function () {
      var _GetWatchListReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(year, month, reportType, includeHistory) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", axios.get("/api/".concat(this._controller, "/GetWatchListReport"), {
                  params: {
                    year: year,
                    month: month,
                    reportType: reportType,
                    includeHistory: includeHistory
                  }
                }));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function GetWatchListReport(_x7, _x8, _x9, _x10) {
        return _GetWatchListReport.apply(this, arguments);
      }

      return GetWatchListReport;
    }()
  }, {
    key: "LogReport",
    value: function () {
      var _LogReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(generatedReport) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", axios.post("/api/".concat(this._controller, "/LogReport"), generatedReport));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function LogReport(_x11) {
        return _LogReport.apply(this, arguments);
      }

      return LogReport;
    }()
  }]);

  return WatchList;
}(BaseData);

export default new WatchList();